// extracted by mini-css-extract-plugin
export var acceptButton = "CookieNotice-module--acceptButton--ILgw4";
export var bxTextTruncateEnd = "CookieNotice-module--bx--text-truncate--end--B60CI";
export var bxTextTruncateFront = "CookieNotice-module--bx--text-truncate--front--COblE";
export var cookieNotice = "CookieNotice-module--cookieNotice--UbBv9";
export var hidden = "CookieNotice-module--hidden---Jo3m";